<script setup>

import { defineProps} from "vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "pedidoDeCompra"
]);

//==================================================================//
//======================= Aprovadores Header =======================//
//==================================================================//

let aprovadoresHeaders = [
    { text: 'Codigo da Aprovação',      value: 'codigo',            class:"c-parcelas__header",    cellClass:'c-parcelas__cell', width:"88px"},
    { text: 'Decisão',                  value: 'decisao',           class:"c-parcelas__header",    cellClass:'c-parcelas__cell', width:"180px"},
    { text: 'Aprovador',                value: 'aprovadorNome',     class:"c-parcelas__header",    cellClass:'c-parcelas__cell', width:"180px"},
    { text: 'Justificativa',            value: 'justificativa',     class:"c-parcelas__header",    cellClass:'c-parcelas__cell'},
    { text: 'Data Decisão',             value: 'dataDecisao',       class:"c-parcelas__header",    cellClass:'c-parcelas__cell', width:"180px"},
]

//==================================================================//
//========================== Cor Decisao ===========================//
//==================================================================//

const corDecisao = (aprovador) =>{

    if(aprovador?.decisao == "Aprovou"){

        return "green"

    }else if( aprovador?.decisao == "Reprovou"){

        return "red"

    }else{

        return "gray"

    }

};

//==================================================================//
//========================= Icone Decisao ==========================//
//==================================================================//

const iconeDecisao = (aprovador) =>{

    if(aprovador?.decisao == "Aprovou"){

        return "mdi-check-circle"

    }else if( aprovador?.decisao == "Reprovou"){

        return "mdi-close-circle"

    }else{

        return "mdi-circle"

    }

};

//==================================================================//
//========================== Data Decisao ==========================//
//==================================================================//

const dataDecisao = (aprovador) =>{

    if(!aprovador?.dataDecisao){
        return "--/--/----"
    }

    return aprovador?.dataDecisao;

}

</script>

<template>

    <v-card
        class="c-aprovadores"
    >

        <v-card-title
            class="c-aprovadores__titulo"
        >
        
            <h3>Aprovadores</h3>

        </v-card-title>

        <div
            class="c-aprovadores__conteudo"
        >

            <v-data-table
                class="c-aprovadores__tabela elevation-1"
                :headers="aprovadoresHeaders"
                :items="props?.pedidoDeCompra?.aprovadores"
                :items-per-page="-1"
                item-key="id"
            >

                <template v-slot:item.decisao="{item}">

                    <v-icon
                        :color="corDecisao(item)"
                        large
                    >
                        {{iconeDecisao(item)}}
                    </v-icon>

                </template>

                <template v-slot:item.dataDecisao="{item}">

                    {{ dataDecisao(item) }}
                
                </template>

            </v-data-table>

        </div>

    </v-card>


</template>

<style scoped>

.c-campo{
    pointer-events: none;
}

.c-aprovadores__tabela{
    display: grid;
    white-space: nowrap;
}

</style>